import { Pane } from '@criteria-labs/react'
import { Service } from '@criteria-labs/docs-kit'
import { useEffect, useState } from 'react'
import { ErrorBoundary } from '../document-view/ErrorBoundary'
import { OpenAPIDocument, useOpenAPIDocumentOpenAPI } from '../documents/OpenAPIDocument'
import { NewBaseURL } from '../inspector/base-url/NewBaseURL'
import { EndpointDetail } from '../inspector/endpoint/EndpointDetail'
import { NewEndpoint } from '../inspector/endpoint/NewEndpoint'
import { NewResource } from '../inspector/resource/NewResource'
import { ResourceDetail } from '../inspector/resource/ResourceDetail'
import { Route, RouterProvider } from '../inspector/router'
import { NewAPIKeyAuth } from '../inspector/security-scheme/NewAPIKeyAuth'
import { NewHTTPAuth } from '../inspector/security-scheme/NewHTTPAuth'
import { NewOAuth2Auth } from '../inspector/security-scheme/NewOAuth2Auth'
import { NewOpenIDConnectAuth } from '../inspector/security-scheme/NewOpenIDConnectAuth'
import { ServiceDetail } from '../inspector/service/ServiceDetail'
import { DispatchChangeProvider } from '../inspector/useDispatchChange'

export function OpenAPIDocumentInspector({ document }: { document: OpenAPIDocument }) {
  const openAPI = useOpenAPIDocumentOpenAPI(document)

  // TODO: add to issues panel
  // const openAPIWarnings = useOpenAPIDocumentOpenAPIWarnings(document)

  // filter out undefined values as text is written to avoid flickering
  const [lastOpenAPI, setLastOpenAPI] = useState(openAPI)
  useEffect(() => {
    if (openAPI) {
      setLastOpenAPI(openAPI)
    }
  }, [openAPI])

  const service = lastOpenAPI ? new Service(lastOpenAPI) : null

  return (
    <ErrorBoundary>
      <DispatchChangeProvider document={document}>
        <RouterProvider>
          <div className="relative h-full">
            {service && (
              <>
                <ServiceDetail service={service} />
                <Route pathname="/resources/{resource_index}">
                  <Pane className="absolute inset-0">
                    <ResourceDetail service={service} />
                  </Pane>
                  <Route pathname="/resources/{resource_index}/new-endpoint">
                    <Pane className="absolute inset-0">
                      <NewEndpoint service={service} />
                    </Pane>
                  </Route>
                </Route>
                <Route pathname="/endpoints/{endpoint_path}/{endpoint_method}">
                  <Pane className="absolute inset-0">
                    <EndpointDetail service={service} />
                  </Pane>
                </Route>
                <Route pathname="/new-endpoint">
                  <Pane className="absolute inset-0">
                    <NewEndpoint service={service} />
                  </Pane>
                </Route>
                <Route pathname="/new-resource">
                  <Pane className="absolute inset-0">
                    <NewResource service={service} />
                  </Pane>
                </Route>
                <Route pathname="/new-base-url">
                  <Pane className="absolute inset-0">
                    <NewBaseURL service={service} />
                  </Pane>
                </Route>
                <Route pathname="/new-api-key-auth">
                  <Pane className="absolute inset-0">
                    <NewAPIKeyAuth service={service} />
                  </Pane>
                </Route>
                <Route pathname="/new-http-auth">
                  <Pane className="absolute inset-0">
                    <NewHTTPAuth service={service} />
                  </Pane>
                </Route>
                <Route pathname="/new-oauth2-auth">
                  <Pane className="absolute inset-0">
                    <NewOAuth2Auth service={service} />
                  </Pane>
                </Route>
                <Route pathname="/new-openid-connect-auth">
                  <Pane className="absolute inset-0">
                    <NewOpenIDConnectAuth service={service} />
                  </Pane>
                </Route>
              </>
            )}
          </div>
        </RouterProvider>
      </DispatchChangeProvider>
    </ErrorBoundary>
  )
}
